import type { NotificationItem } from '@/lib/api/notifications';

type Translate = (key: string, values?: Record<string, unknown>) => string;

export interface NotificationCopy {
  title: string;
  body: string;
}

export function resolveNotificationCopy(
  notification: NotificationItem,
  t: Translate,
  hasKey: (key: string) => boolean,
): NotificationCopy {
  const values: Record<string, unknown> = { ...notification.payload };
  const typePrefix = `types.${notification.type}`;
  const cause =
    notification.type === 'WOOCOMMERCE_CREDENTIALS_INVALID' ||
    notification.type === 'WOOCOMMERCE_UNREACHABLE' ||
    notification.type === 'PROCESSOR_CREDENTIALS_INVALID'
      ? notification.payload.cause
      : undefined;
  const prefixes = cause ? [`${typePrefix}.causes.${cause}`, typePrefix] : [typePrefix];
  const prefix = prefixes.find((candidate) => hasKey(`${candidate}.title`));

  if (prefix === undefined) {
    return { title: t('types.unknown.title'), body: t('types.unknown.body', values) };
  }

  return { title: t(`${prefix}.title`, values), body: t(`${prefix}.body`, values) };
}
